// extracted by mini-css-extract-plugin
export default {"dotsWrapper":"_bb66d060"};